import { cn } from "@/utils/utils"
import * as Accordion from "@radix-ui/react-accordion"
import { ReactNode } from "react"
import { FiChevronDown } from "react-icons/fi"

/** The Radix open/close animation for <Accordion.Content>. Shared so hand-rolled accordions match. */
export const accordionContentClasses =
  "overflow-hidden data-[state=closed]:animate-accordionUp data-[state=open]:animate-accordionDown"

type AccordionItemProps = {
  value: string
  title: string
  titleSize?: "sm" | "md" | "lg"
  chevronSize?: "sm" | "md" | "lg"
  icon?: ReactNode
  className?: string
  children: ReactNode
}

export const AccordionItem = ({
  value,
  title,
  titleSize = "md",
  chevronSize = "md",
  icon,
  className,
  children
}: AccordionItemProps) => (
  <Accordion.Item value={value} className={cn("border-b border-neutral-30", className)}>
    <Accordion.Header className="m-0 flex">
      <Accordion.Trigger className="group flex w-full items-center gap-4 py-3 text-left lg:py-5">
        {icon}
        <span
          className={cn("font-semibold", {
            "text-xs lg:text-sm": titleSize === "sm",
            "text-sm lg:text-base": titleSize === "md",
            "text-[15px] lg:text-[20px]": titleSize === "lg"
          })}
        >
          {title}
        </span>
        <FiChevronDown
          className={cn("ml-auto text-[#6B6F67] transition-transform duration-300 group-data-[state=open]:rotate-180", {
            "text-xl lg:text-3xl 2xl:text-4xl": chevronSize === "sm",
            "text-2xl lg:text-3xl 2xl:text-4xl": chevronSize === "md",
            "text-3xl lg:text-4xl 2xl:text-5xl": chevronSize === "lg"
          })}
        />
      </Accordion.Trigger>
    </Accordion.Header>
    <Accordion.Content className={accordionContentClasses}>
      <div className="pb-4">{children}</div>
    </Accordion.Content>
  </Accordion.Item>
)
